"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import WedgeWireProfileDiagram from "@/components/diagrams/WedgeWireProfileDiagram";
import SlotOrientationDiagram from "@/components/diagrams/SlotOrientationDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function CylindricalScreensPage() {
  const {
    lang
  } = useLanguage();
  const pageData = pick(lang, COPY);
  const {
    content,
    diagramCopy
  } = pageData;
  const diagramSlot = <DiagramSection id="cylindrical-diagrams" title={diagramCopy.sectionTitle} lead={diagramCopy.sectionLead} tone="background">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <DiagramCard index="01" badge="Profile Geometry" title={diagramCopy.profileTitle} description={diagramCopy.profileDesc}>
          <WedgeWireProfileDiagram variant="cylinder" />
        </DiagramCard>

        <DiagramCard index="02" badge="Scraper Friendly" title={diagramCopy.axialTitle} description={diagramCopy.axialDesc}>
          <SlotOrientationDiagram orientation="axial" />
        </DiagramCard>

        <DiagramCard index="03" badge="Rotary Strength" title={diagramCopy.circTitle} description={diagramCopy.circDesc}>
          <SlotOrientationDiagram orientation="circumferential" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagramSlot} />;
}